import { SetterOrUpdater } from 'recoil';

export type Offset = {
  left: number;
  top: number;
};

export type TransForm = {
  bg: string;
  fontSize: string;
};

export enum BGSize {
  Cover = 'cover',
  Contain = 'contain',
  Fill = 'fill',
}

export type RecoilUpdater = (
  valOrUpdater: string | ((currVal: string) => string)
) => void;

export function getOffset(element: HTMLElement): Offset {
  const rect = element.getBoundingClientRect();

  return {
    left: rect.left + window.scrollX,
    top: rect.top + window.scrollY,
  };
}

export const handleScroll = ({ target: { parentElement } }: any) => {
  const element = document.getElementById(
    parentElement.textContent.toLowerCase()
  )!;

  window.scrollTo({
    left: 0,
    top: getOffset(element).top,
    behavior: 'smooth',
  });
};

export const addFill = (tag: string, replaceTag: string, image: string) => {
  return image.replace(tag, replaceTag);
};

export const changeHoverColor = (elementId: string, color: string) => {
  const node = document.getElementById(elementId);

  if (node) node.style.setProperty('--pseudo-color', color);
};

export const changeBackground = (
  elementId: string,
  bg: string,
  bgSize: BGSize,
  filter?: string
) => {
  const node = document.getElementById(elementId);
  if (node) {
    node.style.setProperty('--main-view-bg', `url('${bg}')`);
    node.style.background = `url('${bg}')`;
    node.style.backgroundSize = bgSize;
    node.style.backgroundRepeat = 'no-repeat';

    if (filter) node.style.filter = filter;
  }
};

export const changeFont = (elementId: string, fontFamily: string) => {
  const parentNode = document.getElementById(elementId);

  if (parentNode) parentNode.style.fontFamily = `var(${fontFamily})`;
};

export const handleBackgroundChange = (target: string, setter: RecoilUpdater) =>
  setter(target);

export const disableActiveBackground = (elementId: string, theme?: boolean) => {
  const node = document.getElementById(elementId);

  if (node) {
    node.style.backgroundColor = 'transparent';
    node.style.color = '#a5a5a5';
  }
};

export const loadFontAndBorderColor = (
  navItemIds: string[],
  navItemColors: string[],
  setNavItemColors: SetterOrUpdater<string[]>,
  setNavItemIds: SetterOrUpdater<string[]>
) =>
  navItemIds.forEach((id) =>
    navItemColors.forEach((color) => {
      setNavItemColors([color]);
      setNavItemIds([id]);
      changeHoverColor(id, color);
      changeHoverColor(id, color);
    })
  );

export const getContactButtonHoverColor = (background: string) => {
  const bgs: Record<string, string> = {
    nature: '/static/media/nature.36594d9cff251940614c.jpeg',
    animatedNature: '/static/media/animated_nature.a87fd5ac062512c86a8f.png',
    square: '/static/media/blacksquares.64c8a266090669023716.jpeg',
  };

  if (background.includes(bgs.nature)) return '#2a341895';
  else if (background.includes(bgs.animatedNature)) return '#1c656d85';
  else if (background.includes(bgs.square)) return '#20202080';
  else return 'rgba(160, 160, 160, 0.26)';
};
